import {
  MasterArtworkSearch,
  MasterArtworkSearchActionType,
  MasterArtworkSearchActionTypes,
} from "./data.type";

const initialState: MasterArtworkSearch = {
  artworkLevel: "collection",
  searchCollection: null,
  searchMetaArtwork: null,
  searchPrintingTechnique: null,
  appliedFiltersCollection: undefined,
  appliedFiltersMetaArtwork: undefined,
  appliedFiltersPrintingTechnique: undefined,
  currentPageCollection: 1,
  currentPageMetaArtwork: 1,
  currentPagePrintingTechnique: 1,
  limitCollection: 50,
  limitMetaArtwork: 50,
  limitPrintingTechnique: 50,
  responseDataCollection: null,
  responseDataMetaArtwork: null,
  responseDataPrintingTechnique: null,
};

function reducer(
  state: MasterArtworkSearch,
  action: MasterArtworkSearchActionType,
): MasterArtworkSearch {
  switch (action.type) {
    case MasterArtworkSearchActionTypes.SET_ARTWORK_LEVEL:
      return { ...state, artworkLevel: action.payload.artworkLevel };

    case MasterArtworkSearchActionTypes.SET_SEARCH_COLLECTION:
      return {
        ...state,
        searchCollection: action.payload.searchCollection ?? null,
      };

    case MasterArtworkSearchActionTypes.SET_SEARCH_META_ARTWORK:
      return {
        ...state,
        searchMetaArtwork: action.payload.searchMetaArtwork ?? null,
      };

    case MasterArtworkSearchActionTypes.SET_SEARCH_PRINTING_TECHNIQUE:
      return {
        ...state,
        searchPrintingTechnique: action.payload.searchPrintingTechnique ?? null,
      };

    case MasterArtworkSearchActionTypes.SET_APPLIED_FILTERS_COLLECTION:
      return {
        ...state,
        appliedFiltersCollection: action.payload.appliedFiltersCollection,
      };

    case MasterArtworkSearchActionTypes.SET_APPLIED_FILTERS_META_ARTWORK:
      return {
        ...state,
        appliedFiltersMetaArtwork: action.payload.appliedFiltersMetaArtwork,
      };

    case MasterArtworkSearchActionTypes.SET_APPLIED_FILTERS_PRINTING_TECHNIQUE:
      return {
        ...state,
        appliedFiltersPrintingTechnique:
          action.payload.appliedFiltersPrintingTechnique,
      };

    case MasterArtworkSearchActionTypes.SET_CURRENT_PAGE_COLLECTION:
      return {
        ...state,
        currentPageCollection: action.payload.currentPageCollection ?? 1,
      };

    case MasterArtworkSearchActionTypes.SET_CURRENT_PAGE_META_ARTWORK:
      return {
        ...state,
        currentPageMetaArtwork: action.payload.currentPageMetaArtwork ?? 1,
      };

    case MasterArtworkSearchActionTypes.SET_CURRENT_PAGE_PRINTING_TECHNIQUE:
      return {
        ...state,
        currentPagePrintingTechnique:
          action.payload.currentPagePrintingTechnique ?? 1,
      };

    case MasterArtworkSearchActionTypes.SET_LIMIT_COLLECTION:
      return {
        ...state,
        limitCollection: action.payload.limitCollection ?? 50,
      };

    case MasterArtworkSearchActionTypes.SET_LIMIT_META_ARTWORK:
      return {
        ...state,
        limitMetaArtwork: action.payload.limitMetaArtwork ?? 50,
      };

    case MasterArtworkSearchActionTypes.SET_LIMIT_PRINTING_TECHNIQUE:
      return {
        ...state,
        limitPrintingTechnique: action.payload.limitPrintingTechnique ?? 50,
      };

    case MasterArtworkSearchActionTypes.SET_RESPONSE_DATA_COLLECTION:
      return {
        ...state,
        responseDataCollection: action.payload.responseDataCollection ?? null,
      };

    case MasterArtworkSearchActionTypes.SET_RESPONSE_DATA_META_ARTWORK:
      return {
        ...state,
        responseDataMetaArtwork: action.payload.responseDataMetaArtwork ?? [],
      };

    case MasterArtworkSearchActionTypes.SET_RESPONSE_DATA_PRINTING_TECHNIQUE:
      return {
        ...state,
        responseDataPrintingTechnique:
          action.payload.responseDataPrintingTechnique ?? [],
      };

    default:
      return state;
  }
}

export const MasterArtworkSearchReducer = { initialState, reducer };
